import {
    Text,
    View,
    StyleSheet,
} from '@react-pdf/renderer';

const reportPDFEmptyChartStyles = StyleSheet.create({
    container: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        minHeight: 150,
        height: 150,
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#333333',
    },
});

export default function ReportPDFEmptyChart() {
    return (
        <View style={reportPDFEmptyChartStyles.container}>
            <Text style={reportPDFEmptyChartStyles.text}>No data to display</Text>
        </View>
    );
}
